module.exports = __webpack_public_path__ + "img/Alexcoutcharmtable59.852a52cb.jpg";